import { required } from 'utils/validation'

export default function(values = {}) {
  return {
    aim: required(values.aim)
  }
}
